<div class="loading-screen-wrapper" *ngIf="loading">
    <div class="loading-screen-icon">
      <img src="/assets/images/logo/loading.gif" />
    </div>
  </div>